import { combineReducers } from '@reduxjs/toolkit';

import maintenanceScheduleReducer from './legacy-payment-options-maintenance-schedule.slice';
import legacyCurrenciesReducer from './legacy-payment-options-currencies';
import legacyContextualMessageReducer from './legacy-payment-options-contextual-messages';
import legacyConfigurationModuleReducer from './legacy-payment-options-configuration-module';
import legacyPaymentOptionsCacheReloadReducer from './legacy-payment-options-cache-reload-module';

const legacyPaymentOptionsReducer = combineReducers({
  maintenanceSchedule: maintenanceScheduleReducer,
  currencies: legacyCurrenciesReducer,
  legacyContextualMessages: legacyContextualMessageReducer,
  legacyConfigurationModule: legacyConfigurationModuleReducer,
  legacyPaymentOptionsCacheReload: legacyPaymentOptionsCacheReloadReducer,
});

export default legacyPaymentOptionsReducer;
